import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import styles from "./ServiceLink.module.scss";

const ServiceLink = ({ to, title, description, className }) => {
  return (
    <Link to={to} className={classNames(styles.Link, className)}>
      {title && <span className={styles.Title} dangerouslySetInnerHTML={{__html: title}}></span>}

      {description && <p className={styles.Intro} dangerouslySetInnerHTML={{__html: description}}></p>}
    </Link>
  );
};

export default ServiceLink;
